import { useCallback, useEffect, useRef } from "react"
import type { TModelNumberTableRow } from "types/modelNumbers.type"
import { useSearchParams } from "react-router-dom"

export const useTableModelNumbersHandles = () => {
	const [, setSearchParams] = useSearchParams()

	// react-router re-creates setSearchParams whenever the current params change, and
	// clicking a row changes them (it opens the drawer). Reading the setter from a ref
	// keeps onRowHandle permanently stable, which matters because the collapse items —
	// and therefore every flattened row of the ~2400-item category — are memoized on it.
	const setSearchParamsRef = useRef(setSearchParams)

	useEffect(() => {
		setSearchParamsRef.current = setSearchParams
	}, [setSearchParams])

	const onRowHandle = useCallback(
		(record: TModelNumberTableRow) => ({
			onClick: () => {
				const searParams = new URLSearchParams()
				searParams.set("modelNumberID", String(record.id))
				setSearchParamsRef.current(searParams)
			},
		}),
		[],
	)

	return {
		onRowHandle,
	}
}
